/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardsAccount
 */
export interface RewardsAccount {
    /**
     * 
     * @type {number}
     * @memberof RewardsAccount
     */
    points?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardsAccount
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardsAccount
     */
    courierUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardsAccount
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardsAccount
     */
    creditBalance?: number;
}

/**
 * Check if a given object implements the RewardsAccount interface.
 */
export function instanceOfRewardsAccount(value: object): value is RewardsAccount {
    return true;
}

export function RewardsAccountFromJSON(json: any): RewardsAccount {
    return RewardsAccountFromJSONTyped(json, false);
}

export function RewardsAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardsAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'points': json['points'] == null ? undefined : json['points'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierUserId': json['courierUserId'] == null ? undefined : json['courierUserId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'creditBalance': json['creditBalance'] == null ? undefined : json['creditBalance'],
    };
}

export function RewardsAccountToJSON(json: any): RewardsAccount {
    return RewardsAccountToJSONTyped(json, false);
}

export function RewardsAccountToJSONTyped(value?: RewardsAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'points': value['points'],
        'id': value['id'],
        'courierUserId': value['courierUserId'],
        'courierId': value['courierId'],
        'creditBalance': value['creditBalance'],
    };
}

